module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-vodafonecvm-02.3e9792cd.jpg";